<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="`commonForm_${layout.field}`" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update"></common-form>
        <multi-form :ref="`multiForm_${layout.field}`" :layout="layout" v-if="layout.type==='multiForm'" :can-add="multiFormCanAdd" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFileNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" :disabled="!canSubmit" @click="submit" style="width:120px;">提交</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-modal class="introductionModal" :title="pageLayout.introduction.title" v-if="pageLayout.introduction" v-model="introductionVisible" @ok="introductionVisible=false" :okText="'关闭'">
        <div>
          <pre style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;text-align:left">{{pageLayout.introduction.description}}</pre>
        </div>
      </a-modal>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from 'uuidjs';
import CommonForm from '../../components/CommonForm.vue';
import MultiForm from '../../components/MultiForm.vue';
import Summation from '../../components/Summation.vue';
import ApprovalFlow from '../../components/ApprovalFlow.vue';
import Upload from '../../components/Upload.vue';
import { setTimeout } from 'timers';
import LayoutConfig from '../../utils/LayoutConfig.js';
import { layoutConfig } from '../../utils/mockData.js';
import {
  getPurchaseLayout,
  getCreatePurchaseParams,
  getPurchaseFlow,
  submitPurchase,
  purchaseCache,
} from '../../services/CommonService.js';

export default {
  components: {
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload,
  },
  data() {
    return {
      introductionVisible: false,
      canEdit: true,
      breadcrumb: [
        {
          label: '发起申请',
          path: {
            name: 'launchApplication',
          },
        },
        {
          label: '发起采购申请',
          path: '',
        },
      ],
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      loadedInfo: false,
      canSubmit: true,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      multiFormCanAdd: true,
      defaultFileNone: false,
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf('fromLocation=msg') === -1 ? 'app' : 'msg';
    Promise.all([this.fetchParams('create'), this.fetchParams('default')]).then(
      () => {
        this.fetchPageLayout();
      },
    );
  },
  mounted() {
    this.systemCacheTimer = setInterval(this.systemCache, 20000);
  },
  beforeDestroy() {
    clearInterval(this.systemCacheTimer);
  },

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          undertake_group_id: this.requestParams.basicInfo.undertake_group_id,
          type: this.requestParams.basicInfo.type,
          total_pay: this.requestParams.total_pay,
        };
      }
    },
  },

  methods: {
    // 获取整个页面表单布局
    fetchPageLayout() {
      this.loadedLayout = false;
      getPurchaseLayout({ type: 'create' }).then(res => {
        if (res.status === 'success') {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    // 获取页面表单参数
    fetchParams(type) {
      return getCreatePurchaseParams({ type: type }).then(res => {
        if (res.status === 'success') {
          if (type === 'create') {
            this.loadedInfo = true;
            this.paramsBackup = _.cloneDeep(res.data);
            this.params = {};
            this.params = Object.assign({}, this.params, res.data);
            LayoutConfig.setAllParams(this.params);
          } else {
            this.defaultParams = Object.assign(
              {},
              this.defaultParams,
              res.data,
            ); // 页面默认参数
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo,
      );
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getPurchaseFlow(this.requestParams, this).then(res => {
        if (res.status === 'success') {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf('commonForm') || key.indexOf('multiForm')) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        submitPurchase(this.requestParams).then(res => {
          if (res.status === 'success') {
            this.$Message.success('创建申请成功');
            this.$router.replace({
              name: 'myApplicationList',
              query: {
                apply_type: 7,
              },
            });
          } else {
            this.$Message.error(res.message);
          }
          this.canSubmit = true;
        });
      }
    },
    update(e) {
      this.fetchLayout();
    },
    back() {
      this.$router.replace({
        name: 'launchApplication',
      });
    },
    cancelQuest() {
      if (typeof this.cancelSource === 'function') {
        this.cancelSource('终止请求'); //取消请求
      }
    },
    systemCache() {
      if (this.loadedInfo && this.loadedLayout) {
        purchaseCache({ ...this.requestParams }).then(res => {
          if (res.status === 'success') {
          }
        });
      }
    },
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.undertake_group_id &&
          val.type &&
          val.total_pay &&
          val.total_pay !== '0.00'
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
